export const SET_AS_DEFAULT_HOME_PAGE_BUTTON_TEXT = "activation.set.as.default.text";
export const ALREADY_DEFAULT_HOME_PAGE_BUTTON_TEXT = "activation.set.as.default.already.text";
